/**
 * Fade and rise for home page section content, once per element, on the first time it scrolls into view.
 * The `sustena-reveal` class on <html> is set inline in the head only when IntersectionObserver exists and
 * the visitor has not asked for reduced motion; without it nothing is hidden and this script does nothing.
 */
(() => {
  const root = document.documentElement;
  if (!root.classList.contains('sustena-reveal')) return;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px' }
  );

  /** @param {ParentNode} scope */
  const observe = (scope) => {
    for (const element of scope.querySelectorAll('[data-sustena-reveal]:not(.is-revealed)')) observer.observe(element);
  };

  observe(document);
  window.sustenaRevealReady = true;

  // Theme editor: sections are re-rendered on every change
  document.addEventListener('shopify:section:load', (event) => observe(/** @type {Element} */ (event.target)));
})();
